class ProductRecommendationsSlider {
  constructor(selector) {
    this.selector = selector;
    this.initSlider();
  }

  initSlider() {
    new Swiper(this.selector, {
      slidesPerView: 2,
      spaceBetween: 15,
      navigation: {
        nextEl: `${this.selector} .swiper-button-next`,
        prevEl: `${this.selector} .swiper-button-prev`,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
      keyboard: {
        enabled: true,
      },
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
    });
  }
}

// attach to window so you can call it from anywhere
window.initProductRxcommendationsSlider = function(selector = '.product-recommendations-swiper') {
  new ProductRecommendationsSlider(selector);
}

// optionally call it on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  window.initProductRxcommendationsSlider();
});
